import './Landing.css'
import CustomParticles from './components/CustomParticles'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
export default function Landing() {
    const [showParticles, setShowParticles] = useState(window.innerWidth > 1000)

    useEffect(() => {

        function handleResize() {
            if (window.innerWidth < 1201) {
                setShowParticles(false);
            } else {
                setShowParticles(true)
            }
        }
        
        window.addEventListener("resize", handleResize);
    }, [])

    return (
        <div className='landing'>
            {showParticles ? <CustomParticles numParticles={100} /> : <CustomParticles numParticles={30}/>}
            <div className='landing-name'>Finio</div>
            <div className='landing-content'>
                <div className='landing-title'>Personal financed, simplified.</div>
                <div className='landing-subtitle'>The power of complete visibilty into your personal finance, now right at your fingertips.</div>
            </div>
            <div className='landing-page-buttons-container'>
                <Link to='/signup'><button className='landing-button' id='signup-button'>Sign-up</button></Link>
                <Link to='/login'><button className='landing-button'>Login</button></Link>
            </div>
        </div>
    )
}